module.exports = __webpack_public_path__ + "img/phone.314e1021.svg";